import { render } from "./CreatePrescripcionEstudios.vue?vue&type=template&id=78227bf8&scoped=true"
import script from "./CreatePrescripcionEstudios.vue?vue&type=script&lang=js"
export * from "./CreatePrescripcionEstudios.vue?vue&type=script&lang=js"

import "./CreatePrescripcionEstudios.vue?vue&type=style&index=0&id=78227bf8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78227bf8"]])

export default __exports__